export const ARTICLE_CATEGORIES = [
  "Strategy",
  "Technology",
  "Leadership",
  "Business",
  "Brand",
];

export function normalizeCategories(value) {
  if (Array.isArray(value)) {
    return [
      ...new Set(
        value
          .map((item) => String(item || "").trim())
          .filter((item) => ARTICLE_CATEGORIES.includes(item)),
      ),
    ];
  }

  if (typeof value === "string" && value.trim()) {
    const single = value.trim();
    return ARTICLE_CATEGORIES.includes(single) ? [single] : [];
  }

  return [];
}

export function formatCategoriesDisplay(categories) {
  return normalizeCategories(categories).join(" · ");
}

export function categoriesFromDbArticle(dbArticle) {
  if (!dbArticle) return [];

  if (Array.isArray(dbArticle.categories) && dbArticle.categories.length) {
    return normalizeCategories(dbArticle.categories);
  }

  return normalizeCategories(dbArticle.category);
}
